import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { HiOutlineCheckCircle, HiOutlineExclamationCircle, HiOutlineX } from "react-icons/hi";

export default class ShowNotification extends React.Component {
  constructor(props) {
    super(props);
    this.timer = null;
  }

  componentDidMount() {
    if (this.props.visible) {
      this.startAutoClose();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.startAutoClose();
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  startAutoClose = () => {
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (this.props.handleCloseSuccess) {
        this.props.handleCloseSuccess();
      }
    }, 2500);
  };

  handleClose = () => {
    if (this.timer) clearTimeout(this.timer);
    if (this.props.handleCloseSuccess) {
      this.props.handleCloseSuccess();
    }
  };

  render() {
    const { visible, successmsg, issuccess } = this.props;
    const isSuccess = issuccess !== false;

    return (
      <Dialog
        open={Boolean(visible)}
        onClose={this.handleClose}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          style: {
            borderRadius: "20px",
            padding: "0",
            overflow: "hidden",
            boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
          },
        }}
      >
        <div className="p-6 text-center relative bg-white flex flex-col items-center">
          <button
            type="button"
            onClick={this.handleClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 p-1.5 rounded-lg hover:bg-gray-100 transition-all cursor-pointer"
          >
            <HiOutlineX size={18} />
          </button>

          <div
            className={`w-14 h-14 rounded-full flex items-center justify-center mb-3 shadow-inner ${
              isSuccess
                ? "bg-emerald-100 text-emerald-600 border border-emerald-200"
                : "bg-rose-100 text-rose-600 border border-rose-200"
            }`}
          >
            {isSuccess ? (
              <HiOutlineCheckCircle size={32} />
            ) : (
              <HiOutlineExclamationCircle size={32} />
            )}
          </div>

          <p className="text-base font-bold text-slate-800 px-2 mt-1 mb-4 leading-snug">
            {successmsg || (isSuccess ? "Operation completed successfully!" : "An error occurred")}
          </p>

          <button
            type="button"
            onClick={this.handleClose}
            className={`w-full py-2.5 px-4 rounded-xl text-sm font-bold text-white transition-all shadow-xs cursor-pointer ${
              isSuccess
                ? "bg-teal-600 hover:bg-teal-700 active:scale-98"
                : "bg-rose-600 hover:bg-rose-700 active:scale-98"
            }`}
          >
            OK
          </button>
        </div>
      </Dialog>
    );
  }
}

